import React from 'react';
import { Column } from 'new/elements/Table/types';
import { TableProfile } from 'new/elements/TableProfile';
import { ProfileGroup } from 'new/elements/ProfileGroup/ProfileGroup';
import { ChipBadge } from 'new/elements/ChipBadge';
import { getEffectiveRole } from 'js/lib/ACLUtils';

const accessLabels = {
  collaborator: 'Read only',
  admin: 'Can edit',
  owner: 'Owner',
  sharer: 'Sharer',
};

const aclUsersColumns = [
  {
    name: 'Name',
    field: 'full_name',
    renderRow(row) {
      return <TableProfile name={row.full_name} />;
    },
  },
  {
    name: 'Email address',
    field: 'email',
  },
  {
    name: 'Company',
    field: 'org.name',
  },
  {
    name: 'Access type',
    field: 'members',
    renderRow(row) {
      const role = getEffectiveRole(row);
      return (
        <ChipBadge label={accessLabels[role]} color={role === 'owner' ? 'primary' : 'disabled'} />
      );
    },
  },
] as Column<any>[];

const aclOrgsColumns = [
  {
    name: 'Company',
    field: 'name',
  },
  {
    name: 'Domain',
    field: 'email_domain',
  },
  {
    name: 'Users',
    field: 'members',
    renderRow(row) {
      return <ProfileGroup items={row.members} />;
    },
  },
] as Column<any>[];

const aclTeamsColumns = [
  {
    name: 'Team',
    field: 'name',
  },
  {
    name: 'Description',
    field: 'description',
  },
  {
    name: 'Members',
    field: 'members',
    renderRow(row) {
      return <ProfileGroup items={row.members} />;
    },
  },
] as Column<any>[];

export const aclColumns = {
  users: aclUsersColumns,
  orgs: aclOrgsColumns,
  teams: aclTeamsColumns,
};
